import RoutePath from 'shared/utils/namedUrls';

const basePath = '/student/';

export default {
  studentProfile: new RoutePath(`${basePath}profile/`),
};
